import { render } from "./OnDemandPushPermission.vue?vue&type=template&id=93ab10c6&scoped=true"
import script from "./OnDemandPushPermission.vue?vue&type=script&lang=js"
export * from "./OnDemandPushPermission.vue?vue&type=script&lang=js"

import "./OnDemandPushPermission.vue?vue&type=style&index=0&id=93ab10c6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93ab10c6"]])

export default __exports__